import React from "react";
import Wrapper from "./shared/Wrapper";
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Footer from "./shared/Footer";
import FloatingElement from "../components/AnimatedSection";

// Import all modular components from the propos directory
import HeroSection from "../components/propos/HeroSection";
import VisionSection from "../components/propos/VisionSection";
import ValuesCarousel from "../components/propos/ValuesCarousel";
import FounderTribute from "../components/propos/FounderTribute";
import CEOSpotlight from "../components/propos/CEOSpotlight";
import TechnicalLeadSpotlight from "../components/propos/TechnicalLeadSpotlight";
import TeamGrid from "../components/propos/TeamGrid";

export default function Propos() {

  const navigate = useNavigate();

  return (
    <div className="bg-black text-white overflow-hidden">
      {/* ================================================ */}
      {/* BACKGROUND IDENTIQUE À LA PAGE ACCUEIL */}
      {/* ================================================ */}

      {/* Fond de dégradé principal */}
      <div className="fixed inset-0 bg-linear-to-br from-gray-900 via-black to-blue-900 z-0" />

      {/* Radial linear pour effet de profondeur */}
      <div className="fixed inset-0 bg-[radial-linear(circle_at_30%_50%,rgba(6, 182, 212, 0.1),transparent_50%)] z-0" />

      {/* Étoiles animées (20 étoiles) */}
      <div className="fixed inset-0 overflow-hidden z-0">
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-1 h-1 bg-cyan-400/30 rounded-full"
            initial={{
              x: Math.random() * 100 + 'vw',
              y: Math.random() * 100 + 'vh'
            }}
            animate={{
              x: [null, Math.random() * 100 + 'vw'],
              y: [null, Math.random() * 100 + 'vh']
            }}
            transition={{
              duration: 20 + Math.random() * 10,
              repeat: Infinity,
              ease: "linear"
            }}
          />
        ))}
      </div>

      {/* Éléments flottants de fond - ADAPTÉS AU THÈME SOMBRE */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <FloatingElement x={10} y={20} color="bg-blue-500/10" size={300} delay={0} />
        <FloatingElement x={80} y={40} color="bg-purple-500/10" size={200} delay={0.5} />
        <FloatingElement x={30} y={70} color="bg-cyan-500/10" size={250} delay={1} />
        <FloatingElement x={70} y={10} color="bg-emerald-500/10" size={180} delay={1.5} />
      </div>

      <Wrapper>
        {/* HERO SECTION - Team Photo with Stats */}
        <HeroSection />

        {/* VISION SECTION - Mission & Ambition Tabs */}
        <VisionSection />

        {/* VALEURS SECTION - Carousel horizontal */}
        <ValuesCarousel />

        {/* FOUNDER TRIBUTE SECTION - ULTRA PREMIUM */}
        <FounderTribute />

        {/* SPOTLIGHT SECTION - CEO (Jonas KONUTSE) */}
        {/* <CEOSpotlight /> */}
        <div className="flex items-center justify-center gap-10">

          <div className="flex flex-col sm:flex-row items-center gap-10">
            <CEOSpotlight />

            <TechnicalLeadSpotlight />
          </div>



        </div>


        {/* SPOTLIGHT SECTION - TECHNICAL LEAD (Kahar IDRISSOU) */}
        {/* <TechnicalLeadSpotlight /> */}

        {/* COMPLETE TEAM GRID - ALL TEAM MEMBERS */}
        <TeamGrid />


        {/* CTA FINAL - STYLE SIMILAIRE À L'ACCUEIL */}
        <section className="relative py-32 overflow-hidden">

          <div className="container mx-auto px-4 text-center relative z-10">

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="max-w-4xl mx-auto"
            >
              <h2 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-8">
                Prêt à<span className="bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-600 bg-clip-text text-transparent px-2 sm:px-4">collaborer</span>avec nous ?
              </h2>

              <p className="text-gray-300 text-lg lg:text-xl mb-12 max-w-2xl mx-auto leading-relaxed">
                Rejoignez les entreprises qui ont choisi l'excellence technologique avec Myriade
              </p>

              <div className="flex flex-wrap justify-center gap-6">

                <button
                  onClick={() => navigate("/Contact")}
                  className="cursor-pointer w-[260px] sm:w-[320px] cursor-pointer px-6 py-4 sm:px-8 sm:py-5  text-center text-[14px] sm:text-lg font-medium flex items-center gap-3 bg-linear-to-r from-blue-800 to-blue-600 text-white font-semibold rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/30"
                >
                  <span className="relative z-10 flex items-center gap-1">
                    Discutons de votre projet
                    <ArrowRight className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-2 transition-transform" />
                  </span>

                  <div className="absolute inset-0 bg-linear-to-r from-purple-500 to-pink-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </button>

                <button
                  onClick={() => navigate("/Services")}
                  className="group relative cursor-pointer lg:px-12 px-4 lg:py-6 py-4 border-2 border-gray-700 text-white font-semibold text-[14px] lg:text-lg rounded-2xl hover:border-blue-500/50 hover:bg-white/5 transition-all duration-300"
                >
                  Découvrir nos services
                </button>

              </div>

            </motion.div>

          </div>

        </section>

        {/* FOOTER AVEC MÊME FOND QUE LE HERO */}
        <div className="relative">

          <div className="absolute inset-0 bg-linear-to-br from-gray-900 via-black to-blue-900 z-0" />

          <div className="relative z-10">
            <Footer />
          </div>

        </div>

      </Wrapper>

    </div>

  );

}
